import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";
import List from "../views/List.vue";
import SignUp from "../views/SignUp.vue";
import SignIn from "../views/SignIn.vue";
import CreateSongsData from "../views/CreateSongsData.vue"
import SaveList from "../views/SaveList.vue"
import ListDetails from "../views/ListDetails.vue"
import Contract from "../views/Contract.vue"
import PrivacyPolicy from "../views/PrivacyPolicy.vue"
import firebase from "../firebase/firebase"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/list",
    name: "List",
    component: List,
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/create/songs",
    name: "CreateSongs",
    component: CreateSongsData,
    meta: { requiresAuth: true }
  },
  {
    path: "/create/list",
    name: "SaveList",
    component: SaveList,
    meta: { requiresAuth: true }
  }, {
    path: "/list/:listId",
    name: "ListDetail",
    component: ListDetails,
  }, {
    path: "/contract",
    name: "Contract",
    component: Contract,
  },{
    path: "/privacypolicy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
  }, {
    path: "/test",
    name: "Test",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/TimeSelector.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // 認証状態を取得
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        // 認証されていない場合、認証画面へ
        next({ name: 'SignIn' })
      }
    })
  } else {
    next()
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {
    // 認証状態を取得
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        // 認証されていない場合、認証画面へ
        next({ name: 'SignIn' })
      }
    })
  } else {
    next()
  }
})

export default router;
